import React from 'react'

function Iconfacture ({className='stroke-[#38C3FF]'}) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24"  className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 22H10.7273C7.46607 22 5.83546 22 4.70307 21.2022C4.37862 20.9736 4.09058 20.7025 3.8477 20.3971C3 19.3313 3 17.7966 3 14.7273V12.1818C3 9.21865 3 7.73706 3.46894 6.55375C4.22282 4.65142 5.81714 3.15088 7.83836 2.44135C9.09563 2 10.6698 2 13.8182 2C15.6173 2 16.5168 2 17.2352 2.2522C18.3902 2.65765 19.3013 3.5151 19.732 4.60214C20 5.27832 20 6.12494 20 7.81818V10.5"  strokeidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3 12C3 10.159 4.49238 8.66667 6.33333 8.66667C6.99912 8.66667 7.78404 8.78333 8.43137 8.60988C9.00652 8.45576 9.45576 8.00652 9.60988 7.43136C9.78333 6.78404 9.66667 5.99912 9.66667 5.33333C9.66667 3.49238 11.1591 2 13 2"  strokeidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21 20.4923C20.5216 21.3957 19.6512 22 18.6568 22C17.147 22 15.9231 20.6071 15.9231 18.8889V17.1111C15.9231 15.3929 17.147 14 18.6568 14C19.6512 14 20.5216 14.6043 21 15.5077M15 18H18.9231"  strokeidth="1.5" strokeLinecap="round"/>
    </svg>

  )
}

export default Iconfacture
